import slickModule from './slick'
slickModule()
/*---------------------------------------------------------------------------------

---------------------------------------------------------------------------------*/

const body = $(document.body)
const ua = window.navigator.userAgent.toLowerCase()
const isiOS = ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1 || ua.indexOf('macintosh') > -1 && 'ontouchend' in document
const mq_naviSwtch = '(max-width:1080px)'
const mq_xl = '(max-width:1200px)'
const mq_lg = '(max-width:960px)'
const mq_md = '(max-width:820px)'
const mq_sm = '(max-width:640px)'
const mq_min_sm = '(min-width:640px)'

/*---------------------------------------------------------------------------------
スクロール時にヘッダーに影をつける
---------------------------------------------------------------------------------*/
const addScrollShadow = () => {
  const header = document.querySelector('.l-siteHeader-new');
  const scrollThreshold = 50;

  window.addEventListener('scroll', () => {
    if (window.scrollY > scrollThreshold) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  });
};

/*---------------------------------------------------------------------------------
    fixed header
---------------------------------------------------------------------------------*/

const fixed_header = () => {
  const header = $('.l-siteHeader')
  const h_height = $('.l-siteHeader__subnav').outerHeight()
  const fixClass = 'is-fixed'

  $(window).scroll(function () {
    if ($(this).scrollTop() > h_height) {
      header.addClass(fixClass)
    } else {
      header.removeClass(fixClass)
    }
  })
}

/*---------------------------------------------------------------------------------
    fixed footer
---------------------------------------------------------------------------------*/

const fixed_footer = () => {
  const footer = $('.p-homeFooterCta')
  const additionalScroll = 500;
  const fixClass = 'is-fixed'

  $(window).scroll(function () {
    if ($(this).scrollTop() > additionalScroll) {
      footer.addClass(fixClass)
    } else {
      footer.removeClass(fixClass)
    }
  })
}

/*---------------------------------------------------------------------------------
コードブロックプラグイン用のstyle
---------------------------------------------------------------------------------*/
const codeBlockStyle = () => {
  const wpCodemirrorBlock = document.querySelector('.wp-block-codemirror-blocks-code-block');
  const syntaxhighlighterBlock = document.querySelector('.wp-block-syntaxhighlighter-code ');
  if (wpCodemirrorBlock || syntaxhighlighterBlock) {
    const contentRow = document.querySelector('.l-content-row');
    if (contentRow) {
      contentRow.style.display = 'block';
    }
  }
}
/*---------------------------------------------------------------------------------
  ページ内リンク スムーズスクロール
---------------------------------------------------------------------------------*/

const page_smooth_scrolling = () => {
  let speed = 800
  let header = 110

  let urlHash = location.hash
  if(urlHash) {
    $('body,html').stop().scrollTop(0)
    setTimeout(function () {
      scrollToAnker(urlHash)
    }, 800)
  }

  $('a[href^="#"]').on('click tap', function () {
    let href= $(this).attr("href")
    let hash = href == "#" || href == "" ? 'html' : href
    scrollToAnker(hash)
    return false
  })

  function scrollToAnker(hash) {
    let target = $(hash)
    let position = target.offset().top - header
    $('body,html').stop().animate({scrollTop:position}, speed, 'swing')
  }
}



/*---------------------------------------------------------------------------------
  global navi pull down
---------------------------------------------------------------------------------*/
const gnvi_PullDownMenu = () => {
  const mediaQueryList = window.matchMedia('(min-width: 1200px)');

  const listener = (event) => {
    const trigger = $('.js-pd-trigger')
    const openClass = 'is-open'
    const overlay = $('.l-overlay')

    if (event.matches) {
      // pc
      trigger.on("click", function(){
        if ($(this).hasClass(openClass)) {
          // クリック要素に紐づくプルダウンを閉じる
          $(this).removeClass(openClass)
          overlay.removeClass(openClass)
          $('.l-gnavi__submenu__pc', this).slideUp(100,function(e){
            $(this).stop(false, true)
          })
        } else {
          if (trigger.not($(this)).hasClass(openClass)) {
            // クリック要素以外のプルダウンを全て閉じる
            trigger.not($(this)).removeClass(openClass);
            $('.l-gnavi__submenu__pc', trigger.not($(this))).slideUp(100,function(e){
              $(this).stop(false, true)
            })
          }
          // クリック要素に紐づくプルダウンを開く
          overlay.addClass(openClass)
          $(this).addClass(openClass)
          $('.l-gnavi__submenu__pc', this).slideDown(200,function(e){
            $(this).stop(false, true).css('display', 'flex')
          })
        }
      });
      overlay.on("click", function(){
        // オーバーレイ要素クリック時もプルダウンを閉じる
        $(this).removeClass(openClass)
        overlay.removeClass(openClass)
        $('.l-gnavi__submenu__pc').slideUp(100,function(e){
          $(this).stop(false, true)
        })
      });
    } else {
      // mobile
      trigger.each(function() {
        $(this).find('button').on('click tap', function () {
          if ($(this).parent().hasClass(openClass)) {
            $(this).parent().removeClass(openClass)
            $(this).next().next().slideUp(200,function(e){
              $(this).stop(false, true)
            })
          } else {
            $(this).parent().addClass(openClass)
            $(this).next().next().slideDown(200,function(e){
              $(this).stop(false, true)
            })
          }
        });
      });
    }
  };
  mediaQueryList.addEventListener('change', listener);
  listener(mediaQueryList);
}

/*---------------------------------------------------------------------------------
  footer service navi mobile pull down
---------------------------------------------------------------------------------*/

const ftnav_mobilePullDown = () => {
  const btn = $('.l-siteFooter__ftnavi__label')
  const menu = $('.l-siteFooter__ftnavi__list')
  const openClass = 'is-open'

  btn.each(function() {
    $(this).on('click tap', function () {
      if ($(this).parent().hasClass(openClass)) {
        $(this).parent().removeClass(openClass)
        $(this).nextAll(menu).slideUp(200,function(e){$(this).stop(false, true);})
      } else {
        $(this).parent().addClass(openClass)
        $(this).nextAll(menu).slideDown(200,function(e){$(this).stop(false, true);})
      }
    });
  });
}

/*---------------------------------------------------------------------------------
  pull down
---------------------------------------------------------------------------------*/

const generalPullDown = () => {
  const btn = $('.js-pulldown-btn')
  const content = $('.js-pulldown-content')
  const openClass = 'is-open'

  btn.each(function() {
    $(this).on('click tap', function () {
      if ($(this).parent().hasClass(openClass)) {
        $(this).parent().removeClass(openClass)
        $(this).nextAll(content).slideUp(200,function(e){$(this).stop(false, true);})
      } else {
        $(this).parent().addClass(openClass)
        $(this).nextAll(content).slideDown(200,function(e){$(this).stop(false, true);})
      }
    });
  });
}


/*---------------------------------------------------------------------------------
  tag cloud pulldown
---------------------------------------------------------------------------------*/

const tagCloudPulldown = () => {
  const btn = $('.js-tcpd-btn')
  const box = $('.js-tcpd-box')
  const tagCloud = $('.p-tagcloud')
  let min_height = box.attr('data-pd-min');
  const curHeight = tagCloud.outerHeight()
  const autoHeight = tagCloud.css('height', 'auto').outerHeight()
  const openClass = 'is-open'

  box.css('height', min_height)

  btn.each(function() {
    $(this).on('click tap', function () {
      if ($(this).parent().hasClass(openClass)) {
        $(this).parent().removeClass(openClass)
        $(this).prev(box).animate({height: min_height}, 150);
      } else {
        $(this).parent().addClass(openClass)
        $(this).prev(box).animate({height: autoHeight}, 150);
      }
    });
  });
}


/*--------------------------------------------------------------------------------

---------------------------------------------------------------------------------*/

const selectBoxPlaceholder = () => {
  $('select').on('change', function () {
    $(this).addClass('is-selected');
  });
}

/*---------------------------------------------------------------------------------
  global nav
---------------------------------------------------------------------------------*/

const globalNavi = () => {
  const btn = $('.js-gnavi-btn')
  const openClass = 'is-gnavi-open'
  const layer = $('.l-overlay')
  const gnavi = $('.l-gnavi')
  let activeAction = true


  btn.on('click tap', function (event) {
    event.preventDefault()
    if (activeAction) {
      body.toggleClass(openClass)
      if (body.hasClass(openClass)) {
        navOpen()
      } else {
        navClose()
      }
    }
  })

  layer.on('click tap', function (event) {
    if (activeAction) {
      navClose()
    }
  })

  if (window.matchMedia(mq_naviSwtch).matches) {
    $('.js-navi-close').on('click tap', function (event) {
      if (activeAction) {
        navClose()
      }
    })
  }

  $('a[href^="#"]').on('click tap', function () {
    if (activeAction) {
      navClose()
    }
  })

  function navOpen() {
    activeAction = false
    // bodyFixedOn()
    body.addClass('is-no-scroll')
    btn.addClass('is-clicked')
    // gnavi.fadeIn(100)
    gnavi.css('display', 'block').delay(10).queue(function (next) {
      gnavi.addClass('is-open')
      next()
      activeAction = true
    })
    activeAction = true
  }

  function navClose() {
    activeAction = false
    btn.removeClass('is-clicked')
    body.removeClass('is-no-scroll').removeClass(openClass)
    gnavi.removeClass('is-open').delay(100).queue(function (next) {
      gnavi.css('display', '')
      next()
      activeAction = true
    })
    activeAction = true
  }
}

/*---------------------------------------------------------------------------------

---------------------------------------------------------------------------------*/

$(function () {
  addScrollShadow()
  fixed_header()
  fixed_footer()
  codeBlockStyle()
  page_smooth_scrolling()
  gnvi_PullDownMenu()
  ftnav_mobilePullDown()
  generalPullDown()
  tagCloudPulldown()
  selectBoxPlaceholder()
  globalNavi()
})
